module.exports = __webpack_public_path__ + "resources/img/img_dataquery_m.61f00791230ce0e5706c1c2ffe838981.png";